import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersTextField } from "@mui/x-date-pickers/PickersTextField";
import { forwardRef } from "react";
import muiSytle from "../../style/components-style/muiStyle";
const CustomTextField = forwardRef(function CustomTextField(props, ref) {
  return (
    <PickersTextField
      {...props}
      ref={ref}
      size="small"
      sx={{
        width: "100%",
        "& .MuiFormLabel-root": { fontFamily: "Poppins" },
        "&:hover .MuiFormLabel-root": { color: muiSytle.mainColor },
        "& .MuiFormLabel-root.Mui-focused ": { color: muiSytle.mainColor },
        "&:hover .MuiPickersOutlinedInput-notchedOutline": { borderColor: muiSytle.mainColor },
        "&:hover .MuiPickersInputBase-root": { borderColor: muiSytle.mainColor },
        "& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline": {
          borderColor: muiSytle.mainColor,
          boder: 2,
        },
        "& .MuiPickersInputBase-sectionContent, \
        & .MuiPickersInputBase-sectionBefore, \
        & .MuiPickersInputBase-sectionAfter": {
          fontSize: "15px",
          fontFamily: "Poppins",
        },
      }}
    />
  );
});
const DateSelector = ({ label, value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        slots={{ textField: CustomTextField }}
        slotProps={{
          openPickerButton: {
            size: "16px",
            sx: {
              "&:hover": { color: muiSytle.mainColor, backgroundColor: "transparent", opacity: 1 },
            },
          },
        }}
        sx={{
          "& .MuiPickersTextfield-root": { border: 4, borderColor: "cyan" },
          "& .Mui-focused fieldset": { border: 5, borderColor: muiSytle.mainColor },
        }}
      />
    </LocalizationProvider>
  );
};
export default DateSelector;
